import React from 'react'
import { Box, IconButton, Typography, Paper } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Viewer4dv from './Viewer4dv'
import { Sequence } from '../types/catalog'

interface PlayerViewProps {
  sequence: Sequence
  onClose: () => void
}

const PlayerView: React.FC<PlayerViewProps> = ({ sequence, onClose }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
      }}
    >
      {/* Header with back button and track info */}
      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          p: 2,
          borderRadius: 0,
        }}
      >
        <IconButton
          onClick={onClose}
          size="large"
          sx={{
            bgcolor: 'action.hover',
            '&:hover': {
              bgcolor: 'action.selected',
            },
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h5" component="h2">
            {sequence.title}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {sequence.author}
          </Typography>
        </Box>
      </Paper>

      {/* Player container */}
      <Box
        sx={{
          flex: 1,
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {sequence.scenes.length > 0 && (
          <Viewer4dv
            srcMobile={sequence.scenes[0]!.mobile4DS}
            srcDesktop={sequence.scenes[0]!.desktop4DS}
          />
        )}
      </Box>
    </Box>
  )
}

export default PlayerView
